<app-selector label="Bubble Shooter Game" [isEmptySelectable]="isEmptySelectable" [data]="bubbleShooterGameCoreService.bubbleShooterGamesList$ | async" displayKey="name"
    [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="bubbleShooterGameCoreService.loading" [hint]="hint">
</app-selector>
